import $ from 'cash-dom';
import 'swiper/css/swiper.min.css';
import windowScrollTo from './window-scroll';
function initSotuScrollTo() {
  $('.sotu_topic .sotu__nav').on('click', function (e) {
    e.preventDefault();
    const id = $(this).attr('href');
    const section = $(id).get(0);
    windowScrollTo(section);
  });
}
function initSotuSharingToggle() {
  if (document.querySelector('.sotu_topic')) {
    const share = $('[data-share-sotu]');
    // eslint-disable-next-line no-unused-vars
    $(share).on('click', function (event) {
      $(this).toggleClass('hidden');
      $(this).next().toggleClass('hidden');
    });
  }
}

/* eslint-disable */
function initStickyNav() {
  if (document.querySelector('.sotu_topic') || document.querySelector('.sotu_landing')) {
    const options = {
      root: null,
      threshold: 0,
      rootMargin: '0px'
    };
    const placeholder = $('.sotu__nav-placeholder');
    const sticky = $('.sotu__nav-sticky');
    const target = $('#sotu__nav-sticky-anchor').get(0);
    if ($('#bigpicture').length > 0) {
      const bigPicture = $('#bigpicture').get(0);
      $(window).on('load', function () {
        $('.sotu__share').css('height', bigPicture.offsetTop);
      });
      $(window).on('resize', function () {
        $('.sotu__share').css('height', bigPicture.offsetTop);
      });
      $(window).on('load', function () {
        $('.sotu__nav-sticky-track').css('height', bigPicture.offsetTop);
      });
      $(window).on('resize', function () {
        $('.sotu__nav-sticky-track').css('height', bigPicture.offsetTop);
      });
    } else {
      const footer = document.querySelector('.footer');
      $(window).on('load', function () {
        $('.sotu__share').css('height', footer.offsetTop);
      });
      $(window).on('resize', function () {
        $('.sotu__share').css('height', footer.offsetTop);
      });
    }
    function callback(changes, observer) {
      changes.forEach(change => {
        if (change.intersectionRatio === 0) {
          placeholder.addClass('hide');
          sticky.addClass('sticky');
        } else {
          placeholder.removeClass('hide');
          sticky.removeClass('sticky');
        }
      });
    }
    const observer = new IntersectionObserver(callback, options);
    observer.observe(target);
  }
}

/* eslint-enable */

export default function () {
  initStickyNav();
  initSotuSharingToggle();
  initSotuScrollTo();
}